import { Button } from "@/components/common";
import { cn } from "@/utils/cn";
import { RefreshCw, Trash2 } from "lucide-react";
import React from "react";

interface ChatHeaderProps {
  sessionId: string;
  messageCount: number;
  onRefresh?: () => void;
  onClear?: () => void;
  className?: string;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({
  sessionId,
  messageCount,
  onRefresh,
  onClear,
  className = "",
}) => {
  return (
    <div
      className={cn(
        "flex items-center justify-between p-4 bg-white border-b border-gray-200",
        className
      )}
    >
      {/* Left Section */}
      <div className="flex items-center space-x-4">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">
            Sessão de Chat
          </h2>
          <p className="text-sm text-gray-600">
            ID: {sessionId} • {messageCount} mensagens
          </p>
        </div>
      </div>

      {/* Right Section */}
      <div className="flex items-center space-x-2">
        {onRefresh && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onRefresh}
            className="p-2"
            aria-label="Atualizar chat"
          >
            <RefreshCw size={16} />
          </Button>
        )}

        {onClear && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClear}
            className="p-2 text-error-600 hover:text-error-700 hover:bg-error-50"
            aria-label="Limpar chat"
          >
            <Trash2 size={16} />
          </Button>
        )}
      </div>
    </div>
  );
};
